import { colors, fontWeight } from '../../../packages';

export const sxStyles = {
  drawer: {
    '& .MuiPaper-root': {
      maxWidth: '560px !important',
      overflowX: 'hidden',
      '@media (max-width: 600px)': {
        width: '95% !important',
        maxWidth: '95% !important',
      },
    },
    '& .drawerBody': {
      minHeight: 'calc(100vh - 80px)',
      flexDirection: 'column',
      display: 'flex',
      padding: '15px 0',
      width: '100%',
      boxSizing: 'border-box',
    },
  },
  demographics: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    fontSize: '14px',
    width: '100%',
    boxSizing: 'border-box',
    paddingBottom: '16px',
    paddingLeft: '15px',
    paddingRight: '15px',
    '@media (max-width: 600px)': {
      flexDirection: 'column',
      gap: '12px',
    },
  },
  'demographics.left': {
    display: 'flex',
    gap: '12px',
    alignItems: 'center',
    flexShrink: 1,
    minWidth: 0,
    flexShrink: 0,
    width: '50%',
    '@media (max-width: 600px)': {
      width: '100%',
    },
  },
  'demographics.right': {
    display: 'flex',
    gap: '24px',
    alignItems: 'center',
    textAlign: 'right',
    flexShrink: 0,
    width: '50%',
    '@media (max-width: 600px)': {
      width: '100%',
      justifyContent: 'space-between',
      gap: '12px',
    },
  },
  info: {
    flexGrow: 1,
    overflow: 'hidden',
  },
  wraper: {
    maxWidth: '70%',
  },
  'demographics.name': {
    display: 'flex',
    color: colors.neutral900,
    fontWeight: fontWeight.SEMI_BOLD,
    overflow: 'hidden',
    wordBreak: 'break-word',
    whiteSpace: 'normal',
    lineHeight: 1.4,
    '@media (max-width: 600px)': {
      fontSize: '14px',
      maxWidth: 'calc(100% - 80px)',
    },
  },
  'demographics.nameBadge': {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
    overflow: 'hidden',
    '@media (max-width: 600px)': {
      flexDirection: 'row',
      alignItems: 'center',
      gap: '12px',
    },
  },
  'demographics.id': {
    color: colors.neutral600,
    fontWeight: fontWeight.MEDIUM,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    '@media (max-width: 600px)': {
      fontSize: '12px',
    },
  },
  'demographics.email': {
    color: colors.primary600,
    fontWeight: fontWeight.SEMI_BOLD,
    overflow: 'hidden',
    wordBreak: 'break-word',
    whiteSpace: 'normal',
    '@media (max-width: 600px)': {
      fontSize: '13px',
    },
  },
  'demographics.phone': {
    color: colors.primary600,
    fontWeight: fontWeight.MEDIUM,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    '@media (max-width: 600px)': {
      fontSize: '13px',
    },
  },
  actionItem: {
    flexShrink: 0,
  },
  menuButtonHeader: {
    height: 40,
    minWidth: '40px !important',
    width: 40,
    padding: 0,
    background: colors.white,
    border: `1px solid ${colors.primary300}`,
    borderRadius: '8px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '&:hover': {
      border: `1px solid ${colors.primary300}`,
      backgroundColor: colors.primary50,
    },
    '&:focus': {
      border: `1px solid ${colors.primary500}`,
      backgroundColor: colors.primary50,
    },
  },
  menuItem: {
    fontSize: '14px',
    fontWeight: fontWeight.MEDIUM,
    color: colors.primary500,
    padding: '8px 16px',
    minWidth: '120px',
  },
  divider: {
    margin: '0',
    borderColor: colors.neutral100,
    '@media (max-width: 600px)': {
      marginBottom: '16px',
    },
  },
  messagesContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    overflowY: 'auto',
    flex: 1,
    padding: '16px 15px',
    marginBottom: '60px',
    maxHeight: 'calc(100vh - 250px)',
    backgroundColor: colors.white,
    width: '100%',
    boxSizing: 'border-box',
    '@media (max-width: 600px)': {
      padding: '16px 15px',
      gap: '12px',
      maxHeight: 'calc(100vh - 280px)',
    },
  },
  messageItem: {
    padding: '12px 16px',
    borderRadius: '16px',
    width: '70%',
    minWidth: '50%',
    position: 'relative',
    wordBreak: 'break-word',
    '@media (max-width: 600px)': {
      width: '85%',
      padding: '10px 12px',
    },
  },
  messageContent: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    width: '100%',
  },
  messageText: {
    paddingRight: '60px',
    width: '100%',
  },
  sentMessage: {
    alignSelf: 'flex-end',
    backgroundColor: colors.primary500,
    borderRadius: '8px',
  },
  receivedMessage: {
    alignSelf: 'flex-start',
    backgroundColor: colors.primary50,
    borderRadius: '8px',
  },
  sentTimestamp: {
    fontSize: '11px',
    color: '#FFF',
    opacity: 0.7,
    whiteSpace: 'nowrap',
    position: 'absolute',
    right: '0',
    bottom: '0',
    paddingLeft: '8px',
  },
  receivedTimestamp: {
    fontSize: '11px',
    color: colors.neutral600,
    whiteSpace: 'nowrap',
    position: 'absolute',
    right: '0',
    bottom: '0',
    paddingLeft: '8px',
  },
  messageGroup: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  footer: {
    height: 'auto',
    background: colors.white,
    position: 'absolute',
    bottom: 0,
    width: '100%',
    boxSizing: 'border-box',
    '@media (max-width: 600px)': {
      padding: '0',
      paddingTop: '10px',
    },
    borderTop: `1px solid ${colors.neutral100}`,
    paddingTop: '10px',
    paddingBottom: '10px',
  },
  inputWrapper: {
    display: 'flex',
    alignItems: 'center',
    padding: '6px 12px',
    position: 'relative',
    width: '95%',
    margin: '0 auto',
    boxSizing: 'border-box',
    '& .MuiTextField-root': {
      borderRadius: '6px',
    },
    '@media (max-width: 600px)': {
      width: '90%',
      padding: '10px',
    },
  },
  inputField: {
    flex: 1,
    fontSize: '14px',
    color: colors.neutral500,
    fontWeight: fontWeight.MEDIUM,
    justifyContent: 'center',
    '& .MuiInputBase-root': {
      paddingRight: '40px',
    },
  },
  sendButton: {
    position: 'absolute',
    right: '8px',
    top: '50%',
    transform: 'translateY(-50%)',
    padding: '6px',
    cursor: 'pointer',
  },
};
